import { IonContent, IonLabel, IonPage, IonFab, IonFabButton, IonIcon } from "@ionic/react";
import { downloadOutline } from "ionicons/icons";
import React, { useContext } from "react";
import PageHeader from "./PageHeader";
import { useParams } from "react-router";
import { decodeParam } from "../util/ApiHelper";
import { TranslationMessagesContext } from "../util/Translations";

const DocumentViewer: React.FC = () => {
  const { contentType, fileName, fileURL } = useParams<{
    fileURL: string;
    contentType: string;
    fileName: string;
  }>();
  const decodedFileName = decodeParam(fileName);
  const decodedFileURL = decodeParam(fileURL);
  const decodedContentType = decodeParam(contentType);
  const { translatedMessages } = useContext(TranslationMessagesContext);

  const handleDownload = () => {
    const anchor = document.createElement("a");
    anchor.href = decodedFileURL;
    anchor.download = decodedFileName; // Set the correct file name
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  return (
    <IonPage>
      <PageHeader title={`${decodedFileName}`} showBack />

      <IonContent fullscreen>
        <object
          data={decodedFileURL}
          type={decodedContentType}
          width="100%"
          height="100%"
        >
          <IonLabel color={"warning"}>
            {translatedMessages["ErrDocViewing"]?.MessageText ||
              "This document cannot be viewed on this device"}
          </IonLabel>
        </object>
        <IonFab vertical="bottom" horizontal="end" slot="fixed" style={{ marginRight: "20px" }}>
          <IonFabButton onClick={handleDownload}>
            <IonIcon icon={downloadOutline} />
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default DocumentViewer;
